/**
 * Navigation bridge between Sandbox (plugin) and StudentPortal (shell).
 *
 * When Sandbox is mounted as an MFE inside StudentPortal, the portal passes
 * an `onNavigate` callback to `window.SandboxApp.mount()`. This module stores
 * that callback at the module level so any SPDashboard component can reach it
 * via `useSPNavigate` without prop drilling.
 *
 * Lifecycle:
 *   - `setNavigateToPlatform(fn)` is called by sandboxPlugin.js on mount.
 *   - `clearNavigateToPlatform()` is called by sandboxPlugin.js on unmount.
 *   - Components read it via `getNavigateToPlatform()`.
 */

let _onNavigate = null;

/**
 * Registers the platform navigation callback provided by StudentPortal.
 * @param {function|null} fn
 */
export function setNavigateToPlatform(fn) {
  _onNavigate = typeof fn === "function" ? fn : null;
}

/**
 * Clears the registered callback (called on unmount).
 */
export function clearNavigateToPlatform() {
  _onNavigate = null;
}

/**
 * Returns the registered platform navigation callback, or null when Sandbox
 * is running in standalone mode (not embedded inside StudentPortal).
 * @returns {function|null}
 */
export function getNavigateToPlatform() {
  return _onNavigate;
}
